import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends DatabaseGwService {
  URL_PATH: string = "/profiles";

}
